import { Link } from "react-router-dom";
import ModalBase from "./ModalBase";
import { useModal } from "../../js/hooks/useModal";
import { REPTC_ABOUT, REPTC_TITLE, REPCSP_TITLE } from "../../js/utils/reptc";
import { PLATFORM_DISCLAIMER } from "../../js/legal/copy";
import { useClientPortal } from "../../js/hooks/useClientPortal";

export default function SystemInfoModal() {
  const modal = useModal("systemInfo");
  const portal = useClientPortal();
  if (portal.active) return null;
  return (
    <ModalBase isOpen={modal.isOpen} title="About this system" onClose={modal.close} compact quiet>
      <p className="muted">{REPCSP_TITLE}</p>
      <p>{REPTC_ABOUT}</p>
      <p className="muted">{REPTC_TITLE}</p>
      <p className="legal-inline-disclaimer">{PLATFORM_DISCLAIMER}</p>
      <p className="muted">
        <Link to="/eula" onClick={modal.close}>
          End User License Agreement
        </Link>
        {" · "}
        <Link to="/disclaimer" onClick={modal.close}>
          Disclaimer
        </Link>
      </p>
    </ModalBase>
  );
}
